<template>
  <div id="navBar">
    <b-navbar toggleable="lg" type="dark" class="modern-navbar d-flex justify-content-between">
      <b-navbar-brand href="/" class="navbar-brand-modern">
        <img class="logo-img" height="80px" alt="Chill Byte Solutions"
          src="../../assets/chillbytesolutionslogo.png" />
      </b-navbar-brand>

      <b-navbar-toggle v-if="isSmallScreen" target="nav-collapse" class="navbar-toggle-modern">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="x" class="toggle-icon"></b-icon>
          <b-icon v-else icon="list" class="toggle-icon"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="navbar-collapse-modern">
        <b-navbar-nav class="ml-auto navbar-nav-modern">
          <b-nav-item href="/" class="nav-item-modern">INICIO</b-nav-item>
          <b-nav-item href="/nosotros" class="nav-item-modern">NOSOTROS</b-nav-item>
          <b-nav-item-dropdown text="SOLUCIONES" right class="nav-dropdown-modern">
            <b-dropdown-item to="/portal-facturacion" class="dropdown-item-modern">
              <span class="dropdown-icon">🗔</span>
              Portal de Facturación CFDI 4.0
            </b-dropdown-item>
            <b-dropdown-item to="/desarrollo-netsuite" class="dropdown-item-modern">
              <span class="dropdown-icon">🗋</span>
              Consultoría y Desarrollo NetSuite
            </b-dropdown-item>
            <b-dropdown-item to="/pos-netsuite" class="dropdown-item-modern">
              <span class="dropdown-icon">▣</span>
              POS conectado a NetSuite
            </b-dropdown-item>
            <b-dropdown-item to="/conciliador-bancario-netsuite" class="dropdown-item-modern">
              <span class="dropdown-icon">⇄</span>
              Conciliador Bancario
            </b-dropdown-item>
            <b-dropdown-item to="/soluciones-fiscales-netsuite" class="dropdown-item-modern">
              <span class="dropdown-icon">✓</span>
              Soluciones Fiscales NetSuite
            </b-dropdown-item>
            
          </b-nav-item-dropdown> 
          <b-nav-item href="/blog" class="nav-item-modern">BLOG</b-nav-item>
          <b-nav-item to="/costos" class="nav-item-modern">PRECIOS</b-nav-item>
          <b-nav-item href="/chbs-ai-netsuite" class="nav-item-modern">ASISTENTE AI</b-nav-item>
          <!-- <b-nav-item href="#contact" class="nav-item-modern nav-cta">CONTACTO</b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>

export default {
  name: "NavBar",
  data() {
    return {
      expanded: true,
      isSmallScreen: false
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isSmallScreen = window.innerWidth < 900;
    }
  }
};
</script>
